import { render, staticRenderFns } from "./t-products-card.vue?vue&type=template&id=34331434&"
import script from "./t-products-card.vue?vue&type=script&lang=js&"
export * from "./t-products-card.vue?vue&type=script&lang=js&"
import style0 from "./t-products-card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports